import React from "react";

const Author = () => {
  return (
    <section className="py-20 px-6 bg-gray-900 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-12">COM QUEM VOCÊ IRÁ APRENDER?</h2>
        
        {/* Author Photo */}
        <div className="w-32 h-32 mx-auto mb-8 rounded-full overflow-hidden shadow-xl">
          <img 
            src="https://customer-assets.emergentagent.com/job_jesus-livro/artifacts/jm7dfab9_Desperte%20Sua%20Nova%20Identidade%20em%20Cristo%20com%20Hipnose.jpg" 
            alt="Marcio Bringhenti - Autor do livro A Vida de Jesus"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="space-y-4 text-lg leading-relaxed">
          <p>
            <strong>Marcio Bringhenti</strong> - Autor de "A Vida de Jesus: O Evangelho da Prosperidade Eterna"
          </p>
          
          <p>
            Anos de estudo profundo das Escrituras Sagradas e harmonização dos evangelhos;
          </p>
          
          <p>
            Experiência em narrativa bíblica transformadora que conecta leitores diretamente com os ensinamentos de Cristo;
          </p>
          
          <p>
            Criou uma metodologia única de leitura participativa onde o leitor se torna parte ativa da jornada de Jesus;
          </p>
          
          <p>
            Desenvolveu um formato inovador que combina os quatro evangelhos em uma narrativa fluida e envolvente;
          </p>
          
          <p>
            Especialista em aplicação prática dos princípios bíblicos na vida moderna;
          </p>
          
          <p>
            Focado em ajudar pessoas a descobrirem a verdadeira prosperidade eterna através da transformação espiritual;
          </p>
          
          <p>
            Já impactou milhares de vidas através de seus escritos sobre crescimento espiritual e propósito de vida.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Author;